
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import SupportRequestForm from '@/components/SupportRequestForm';

interface SupportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultValues?: {
    name?: string;
    email?: string;
  };
}

const SupportDialog = ({ open, onOpenChange, defaultValues }: SupportDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Contact Support</DialogTitle>
          <DialogDescription>
            Please provide the details below to request support assistance.
          </DialogDescription>
        </DialogHeader>
        
        <SupportRequestForm 
          defaultValues={defaultValues}
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SupportDialog;
